"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createSessionExpiresAt = exports.AssistedCCHelper = void 0;
const helper_types_1 = require("./helper.types");
const contactCenter_1 = require("../../../features/contactCenter");
class AssistedCCHelper {
    constructor(API) {
        this.requestAgentData = (_a) => __awaiter(this, [_a], void 0, function* ({ agentUsername, agentPassword, clientId, keycloakHost }) {
            const urlencoded = new URLSearchParams();
            urlencoded.append('grant_type', 'password');
            urlencoded.append('client_id', clientId);
            urlencoded.append('username', agentUsername);
            urlencoded.append('password', agentPassword);
            const loginData = yield this.API.POST(`${keycloakHost}/realms/master/protocol/openid-connect/token`, urlencoded, {
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                },
            });
            const data = loginData.data;
            return {
                accessToken: data.access_token,
                refreshToken: data.refresh_token,
            };
        });
        this.requestAgentDataAsis = (_a) => __awaiter(this, [_a], void 0, function* ({ agentUsername, agentPassword, host }) {
            const myHeaders = new Headers();
            myHeaders.append('Content-Type', 'application/json');
            const raw = {
                user: agentUsername,
                password: agentPassword,
            };
            const response = yield this.API.POST(`${host}/ccauthentication/agentauthentication`, raw, {
                headers: {
                    'Content-Type': 'application/json',
                },
            });
            const data = response.data;
            return data;
        });
        this.requestInteractionId = (_a) => __awaiter(this, [_a], void 0, function* ({ agentUsername }) {
            const interactionId = (0, contactCenter_1.createInteractionId)();
            const raw = {
                InteractionID: interactionId,
                Fecha: new Date().toISOString(),
                Tipo: 'voz',
                Agente: agentUsername,
            };
            const response = yield this.API.POST('https://wspre.genesys-bt.openbank.corp/WebAPIIV/Api/IV', raw, {
                headers: {
                    'Content-Type': 'application/json',
                },
            });
            const data = response.data;
            return data.interactionId;
        });
        this.requestPasswordPosition = (_a) => __awaiter(this, [_a], void 0, function* ({ documentType, username, accessToken, host, }) {
            const raw = {
                documentType: documentType,
                username: username,
            };
            const response = yield this.API.POST(`${host}/mb-api-auth/authentication/users/password-positions`, raw, {
                headers: {
                    'accessToken': accessToken,
                    'Content-Type': 'application/json',
                },
            });
            const data = response.data;
            return data.positions;
        });
        this.requestLogin = (_a) => __awaiter(this, [_a], void 0, function* ({ documentType, username, accessToken, password, passwordPositions, host, interactionId, }) {
            const raw = {
                documentType: documentType,
                password: password,
                passwordPosition: passwordPositions,
                username: username,
                deviceInformation: {
                    deviceUUID: 'c49edf1f-8aff-41ba-abf5-7ff931a77001',
                    webDeviceInfo: {
                        version: 'Mozilla/5.0 (Macintosh; Intel Mac OS X 10_15_7) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/95.0.4638.69 Safari/537.36',
                    },
                    sessionId: interactionId,
                },
            };
            const response = yield this.API.POST(`${host}/mb-api-auth/authentication/login`, raw, {
                headers: {
                    'accessToken': accessToken,
                    'Content-Type': 'application/json',
                },
            });
            return response.data;
        });
        this.API = API;
    }
}
exports.AssistedCCHelper = AssistedCCHelper;
const createSessionExpiresAt = () => new Date(Date.now() + helper_types_1.timeUp);
exports.createSessionExpiresAt = createSessionExpiresAt;
//# sourceMappingURL=helper.js.map